/**
 * @file Default configuration for the application.
 */

/**
 * @typedef {object} OIDCConfig
 * @property {string} authorizationUrl OAuth issuer URL.
 * @property {string} clientId OAuth client ID.
 * @property {string} redirectUri Redirect to this URI on successful OAuth authentication.
 * @property {string} postLogoutRedirectUri Redirect to this URI on successful OAuth logout.
 * @property {string} scope Scopes to request.
 */

/**
 * @typedef {object} NetworkConfig
 * @property {string} apiKey API key.
 * @property {string} apiBaseUrl API URL.
 * @property {OIDCConfig} oidc OIDC configuration.
 */

/** @type {NetworkConfig} */
export default {
  apiKey: process.env.REACT_APP_API_KEY,
  apiBaseUrl: 'https://demo.internal.verosource.vsfcloud.com/digital-twin',
  oidc: {
    authority:
      'https://demo.internal.verosource.vsfcloud.com/keycloak/realms/master',
    clientId: 'digital-twin-oauth',
    redirectUri:
      'https://digital-twin.demo.internal.verosource.vsfcloud.com/callback',
    postLogoutRedirectUri:
      'https://digital-twin.demo.internal.verosource.vsfcloud.com/signout',
    scope: 'openid',
  },
};
